import axios from 'axios';
import storage from "local-storage-fallback";

export default async function({ route, store, redirect }) {
  const paths = [
    '/a',
    '/b',
    '/c',
    '/d',
    '/e',
    '/f',
    '/us-a',
    '/us-b',
    '/us-c',
    '/us-d',
    '/us-f',
    '/us-bulk-sms-a',
    '/us-bulk-sms-b',
    '/au',
    '/us',
    '/sms-marketing-sales',
    '/white-label-sms',
    '/integration-partners',
    '/become-a-partner',
    '/customer-advisory-board',
    '/sms-automation',
    '/au-sms-offer-eofy23',
    '/au-sms-marketing-eofy23',
    '/nz-sms-offer-eofy23',
    '/nz-sms-marketing-eofy23',
    '/us-sms-offer-eofy23',
    '/us-sms-marketing-eofy23',
    '/referral',
    '/on-demand-rethinking-messaging-as-part-of-your-marketing-mix'
  ];
  const pathHere = route.path.replace(/\/+$/, '');

  const localStorage = !("localStorage" in window) ? storage : window.localStorage;

  if (paths.includes(pathHere)) {
    const burstGeo = JSON.parse(localStorage.getItem('burst-geo-2'));

    const blockListCountry = (process.env.FILTER_COUNTRY || '').split(',');
    const blockListIP = (process.env.FILTER_IP || '').split(',');
    const whiteListIP = (process.env.FILTER_IP_WHITE || '').split(',');
    let blackListed = null;
    if (!burstGeo) {
      // blackListed = await axios
      //   .get(`https://www.cloudflare.com/cdn-cgi/trace`)
      //   .then(function(response) {
      //     if (response && response.data) {
      //       let data = response.data
      //         .replace(/[\r\n]+/g, '","')
      //         .replace(/=+/g, '":"');
      //       data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
      //       data = JSON.parse(data);

      //       localStorage.setItem(
      //         'burst-geo-2',
      //         JSON.stringify({
      //           data,
      //           country_code: data.loc,
      //           ip: data.ip
      //         })
      //       );

      //       if (whiteListIP.includes(data.ip)) {
      //         return false;
      //       }

      //       return (
      //         blockListCountry.includes(data.loc) ||
      //         blockListIP.includes(data.ip)
      //       );
      //     }
      //     // console.log(response.data);
      //     return false;
      //   })
      //   .catch(function(error) {
      //     console.log('CLOUDFLARE API Failed', error);
      //     return null;
      //   });

      if (blackListed === null) {
        blackListed = await axios
          .get(
            `https://api.ipgeolocation.io/ipgeo?apiKey=${process.env.IPGEO_IP}`
          )
          .then(function(response) {
            if (response && response.data) {
              localStorage.setItem(
                'burst-geo-2',
                JSON.stringify({
                  data: response.data,
                  country_code: response.data.country_code2,
                  ip: response.data.ip
                })
              );

              if (whiteListIP.includes(response.data.ip)) {
                return false;
              }

              return (
                blockListCountry.includes(response.data.country_code2) ||
                blockListIP.includes(response.data.ip)
              );
            }
            // console.log(response.data);
            return false;
          })
          .catch(function(error) {
            console.log('IPGEO API Failed', error);
            return false;
          });
      }

      if (blackListed) {
        return redirect('/unavailable/');
      }
    } else {
      if (whiteListIP.includes(burstGeo.ip)) {
        return false;
      }

      if (
        blockListCountry.includes(burstGeo.country_code) ||
        blockListIP.includes(burstGeo.ip)
      ) {
        return redirect('/unavailable/');
      }
    }

    return true;
  }
}
